<template>
  <header
    id="header"
    class="bg-white border-b border-gray-200 sticky top-0 z-50"
  >
    <div class="max-w-7xl mx-auto px-5">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center space-x-3">
          <div
            @click="router.push('/')"
            class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center cursor-pointer"
          >
            <i class="fas fa-leaf text-white text-lg"></i>
          </div>
          <div @click="router.push('/')" class="cursor-pointer">
            <h1 class="text-xl font-semibold text-accent">{{ $t('header.title') }}</h1>
            <p class="text-xs text-gray-500">{{ $t('header.subtitle') }}</p>
          </div>
        </div>
        <div class="flex items-center space-x-4">
          
          <!-- Language selector -->
          <div class="relative">
            <select
              :value="languageStore.currentLanguage"
              @change="handleLanguageChange"
              class="bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option
                v-for="language in languageStore.availableLanguages"
                :key="language.code"
                :value="language.code"
              >
                {{ language.flag }} {{ language.name }}
              </option>
            </select>
          </div>
          
          <!-- Help button -->
          <button class="text-gray-600 hover:text-primary">
            <i class="fas fa-question-circle text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useLanguageStore } from "@/stores/language";
import { computed } from "vue";
import type { SupportedLanguage } from "@/stores/language";

const router = useRouter();
const authStore = useAuthStore();
const languageStore = useLanguageStore();

// Computed properties for safer access
const isLoggedIn = computed(() => authStore?.isLoggedIn || false);
const isLoading = computed(() => authStore?.loading || false);
const userName = computed(() => authStore?.userName);
const userEmail = computed(() => authStore?.userEmail);

const handleLanguageChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  languageStore.setLanguage(target.value as SupportedLanguage);
};

const handleLogin = async () => {
  try {
    if (authStore) {
      await authStore.login('sor');
    }
  } catch (error) {
    console.error('Login failed:', error);
  }
};

const handleLogout = async () => {
  try {
    if (authStore) {
      await authStore.logout();
    }
  } catch (error) {
    console.error('Logout failed:', error);
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
